import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { UserAuth } from '../context/AuthContext';
import ModalExpiracionSesion from './modales/ModalExpiracionSesion';
import useAutoLogout from './hooks/useAutoLogout';
import { cerrarSesion } from '../Redux/usuarios';
import { useNavigate } from 'react-router-dom';

const SessionManager = ({ stateLoggin }) => {
  const dispatch = useDispatch();
  const { logout } = UserAuth();
  const navigate = useNavigate();

  const { modalOpen, setModalOpen, loggedUser, changeState, timeLeft } = useAutoLogout(false);

  const handleSessionExpire = (closeSession) => {
    setModalOpen(false);
    if(closeSession) {
      try {
        logout()
        dispatch(cerrarSesion())
        navigate('/')
        // console.log("cerraste la sesion")
      } catch (error) {
          console.log(error.message)
      }
    }

  };
  
  useEffect(() => {
    // console.log(stateLoggin)
    if(stateLoggin != null) {
      changeState(stateLoggin);
    }
  }, [stateLoggin]);

  return (
    <div>
      <ModalExpiracionSesion
        open={modalOpen}
        handleClose={handleSessionExpire}
        titulo={"¿Estás ahí?"}
        texto={`Su sesión está a punto de expirar por inactividad en ${timeLeft} segundos.`}
      />
    </div>
  );
};

export default SessionManager;
